import classNames from "classnames";
import React, { memo } from "react";
import { CSSTransition } from "react-transition-group";
import "./UniversalInput.scss";

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';

const UniversalInput = memo(
  ({
    label,
    id,
    name,
    type,
    placeholder,
    onChangeValue,
    onBlur,
    value,
    required,
    leftIcon,
    size,
    withFullWidth = true,
    isClearButtonActive,
    onClearSearch,
    onKeyUp,
    onClick,
    disabled,
  }) => {
    const handleChange = (event) => {
      if (name) {
        onChangeValue?.(event.target.value, name);
      } else {
        onChangeValue?.(event.target.value);
      }
    };

    const handleBlur = (event) => {
      onBlur?.(event.target.value)
    }

    return (
      <div className="universal-input">
        {!!label &&
          <label
            className="universal-input__label"
            htmlFor={id}
          >
            {label}
          </label>
        }

        {!!leftIcon &&
          <div className="universal-input__icon--left">
            {leftIcon}
          </div>
        }

        <CSSTransition
          in={isClearButtonActive && !!value}
          timeout={150}
          unmountOnExit
          classNames="animation"
        >
          <div
            className="universal-input__icon--clear"
            onClick={onClearSearch}
          >
            <CloseIcon />
          </div>
        </CSSTransition>
        
        <input
          className={classNames({
            "universal-input__input": true,
            "universal-input__input--sm": size === "sm",
            "universal-input__input--icon-left": !!leftIcon,
            "universal-input__input-width--max-content": !withFullWidth,
          })}
          
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          disabled={disabled}
          onChange={handleChange}
          value={value}
          onBlur={handleBlur}
          onKeyUp={onKeyUp}
          onClick={onClick}
          required={required}
        />
      </div>
    );
  }
);

export default UniversalInput;
